module.exports = __webpack_public_path__ + "img/pasture_cynodon_middle.3fe9f158.webp";